import { createSlice } from "@reduxjs/toolkit";
import getInvoiceDiscountRequestApi from "@custom/rtk-apis/billing/doctorDiscount/invoiceWithDiscountRequest";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  pagination: null,
  error:""
};

const getInvoiceDiscountRequestSlice = createSlice({
  name: "getInvoiceDiscountRequestSlice",
  initialState,
  reducers: {
    cleargetInvoiceDiscountRequest: (state) => {
        state.status = "";
        state.result = null;
        state.msg = "";
        state.loading = false;
        state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceDiscountRequestApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getInvoiceDiscountRequestApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
        state.pagination = payload.pagination; // ✅ Add this
      })
      .addCase(getInvoiceDiscountRequestApi.rejected, (state, { payload }) => {
        state.loading = false;
        state.status = 'error';
        state.error = payload?.message || 'Failed to fetch data';
        state.result = null;
        state.msg = '';
      });
  },
});

export default getInvoiceDiscountRequestSlice.reducer;
export const { cleargetInvoiceDiscountRequest } = getInvoiceDiscountRequestSlice.actions;
